import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function FirstTimeHomebuyersPage() {
  return (
    <LoanProgramTemplate
      title="First Time Homebuyer Program"
      subtitle="Alternative Options"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1777907356/FTBH_yig0oe.png"
      descriptionBold="First‑time homebuyer programs"
      description="make purchasing a first home more affordable by offering reduced upfront costs and special incentives. They support buyers who are new to the process and need a more accessible path into homeownership."
      whyBuyersConsider="These programs may lower upfront expenses and provide added financial support, helping first time buyers enter the market with more confidence and less strain on budgets."
      eligibilityItems={[
        'Buyer must be purchasing a primary residence',
        'Some programs include income or location limits',
        'A brief homebuyer education course may be required',
      ]}
      benefitsItems={[
        'Helps conserve savings for move in or emergency costs',
        'Expands access to additional assistance programs',
        'Supports a smoother financial transition into homeownership',
      ]}
    />
  );
}
